import './App.css';
import { Home } from './ui/page/home/home';
import { HashRouter, Routes, Route } from 'react-router-dom';
import QuemSomos from './ui/page/quem_somos/quem_somos';
import Programas from './ui/page/programas/programas';
import ContrateAprendiz from './ui/page/contrate_aprendiz/contrate_aprendiz';

function App() {
  return (
    <HashRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/quem-somos" element={<QuemSomos />} />
          <Route path="/programas" element={<Programas />} />
          <Route path="/contrate-aprendiz" element={<ContrateAprendiz />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </div>
    </HashRouter>
  );
}

export default App;
